<template>
	<div class="con">
		<div class="time">
			<div class="time-year">
				<van-cell is-link @click="showPopup">{{columns[columnsIndex]}}</van-cell>
				<van-popup :close-on-click-overlay=false position="bottom" :style="{ height: '30%' }" v-model="columnsShow">
					<div class="time-choose">
						<div @click="cancel">取消</div>
						<div class="choose" @click="GetChooseIndex">确定</div>
					</div>
					<van-picker :columns="columns" @change="onChangeReg" />
				</van-popup>
			</div>
			<div class="time-nav">
				<div class="time-nav-num" v-for="(item,index) in Month" @click="getMothList(index)" :class="[index == MonthIndex ? 'MonthCative':'']">{{item.text}}</div>
			</div>
		</div>
		<div class="head">
			<div id="chart_line"></div>
		</div>
		<div class="text">住院数据分享</div>
		<div class="list">
			<div id="chart_bar"></div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'staHospital',
		data() {
			return {
				columns: [],//年列表
				columnsIndex: 0,//选择年下标
				cIndex: 0,//确定后的下标
				columnsShow: false,
				Month:[],
				MonthIndex: 0,
			}
		},
		methods: {
			//获取年
			getMothList(e){
				this.MonthIndex = e;
			},
			//显示底部弹出框
			showPopup() {
		      this.columnsShow = true;
		      this.cIndex = this.columnsIndex;
		    },
		    //选择年份获取下标
			onChangeReg(picker, value, index) {
				console.log(index)
		      	this.columnsIndex = index;
		      	this.newMonth();
		    },
		    //确定
		    GetChooseIndex(){
		    	this.columnsShow = false;
		    	this.newMonth();
		    	this.MonthIndex = 0;
		    },
		    //取消选择
		    cancel(){
		    	this.columnsShow = false;
		    	this.columnsIndex = this.cIndex;
		    	this.newMonth();
		    },
		    //年
			newTime(){
				let newYear = new Date().getFullYear();
				let yearList = [];
				for(let i = 0; i < 3; i++) {
					yearList.push(newYear - i)
				}
				this.columns = yearList;
			},
			//月
			newMonth(){
				let newYear = new Date().getFullYear();
				let monthList = [];
				if(newYear == this.columns[this.columnsIndex]){//当前年
					let newMonth = new Date().getMonth() + 1;
					monthList.push({text:'全年'})
					for(let i = newMonth;i > 0;i--){
						monthList.push({
							text: i +'月'
						})
					}
					this.Month = monthList;
				}else{
					monthList.push({text:'全年'})
					for(let i = 12;i > 0;i--){
						monthList.push({
							text: i +'月'
						})
					}
					this.Month = monthList;
				}
			},
		//柱形图
			totalBar() {
				let myChartBar = this.$echarts.init(document.getElementById('chart_bar'));

				let option = {
					color: ['#3398DB'],
					tooltip: {
						trigger: 'axis',
						axisPointer: { // 坐标轴指示器，坐标轴触发有效
							type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
						}
					},
					grid: {
						left: '2%',
						right: '2%',
						top: '2%',
						bottom: '3%',
						containLabel: true
					},
					xAxis: [{
						type: 'value',
						show: false,
						axisTick: {
							alignWithLabel: true
						},
					
					}],
					yAxis: [{
						type: 'category',
						data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
						splitLine: {
							show: false
						},
						axisTick: {
							show: false
						},
						nameTextStyle: {
							fontSize: 16,
						},
						axisLabel: {
							interval: 0,
							rotate: 40,
							textStyle: {
								color: '#000',
							}
						},
						axisLine: { //y轴
							show: false
						},
					}],
					series: [{
						type: 'bar',
						barWidth: '60%',
						barGap: '50%',
						data: [820, 932, 901, 934, 800, 700, 626, 875, 946, 786, 763, 687],
						label: {
							show: true,
							formatter: '{c}',
							color: '#000'
						},
						itemStyle: {
							normal: {
								barBorderRadius: [0, 10, 10, 0],
								color: '#FFF'
								//								color: new this.$echarts.graphic.LinearGradient(
								//									0, 0, 1, 0, [{
								//											offset: 0,
								//											color: '#fff'
								//										},
								//										{
								//											offset: 1,
								//											color: '#27BEC4'
								//										}
								//
								//									]
								//								)
							}
						}
					}]
				};
				myChartBar.setOption(option);
			},
			//折线图
			totalLine() {
				let myChartLine = this.$echarts.init(document.getElementById('chart_line'));

				let option = {
					grid: {
						left: '-8%',
						right: '3%',
						top: '5%',
						bottom: '5%',
						containLabel: true
					},
					tooltip: {
						formatter: '{b}\n{c}'
					},
					xAxis: {
						type: 'category',
						axisLine: { //这是x轴文字颜色
							lineStyle: {
								color: "#fff",
							}
						},

						boundaryGap: false,
						data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
					},

					yAxis: {
						type: 'value',
						show: false,
						
					},
					series: [{
						data: [820, 932, 901, 934, 800, 700, 626, 875, 946, 786, 763, 687],
						type: 'line',
						smooth: true,
						symbolSize: 8, //设定实心点的大小
						areaStyle: {
							normal: {
								color: '#27BEC4'
							}
						},
						itemStyle: {
							normal: {
								color: '#27BEC4', //改变折线点的颜色
								lineStyle: {
									color: '#fff' //改变折线颜色
								}
							}
						},

					}]
				};
				myChartLine.setOption(option);
			},
		},

		mounted() {
			this.totalBar();
			this.totalLine();
			this.newTime();
			this.newMonth();
		},
		created() {

		},
	}
</script>

<style scoped>
	.time{
		display: flex;
		align-items: center;
		background-color: #fff;
		font-size: 15px;
	}
	.van-cell{
		padding: 10px 10px;
		background: linear-gradient(#ccc,#27BEC4);
		color: #fff;
		font-size: 18px;
	}
	.time-choose{
		padding: 10px 20px;
		display: flex;
		justify-content: space-between;
	}
	.choose{
		color: #0570DB;
	}
	.van-popup{
		overflow: hidden;
	}
	.time-nav{
		display: flex;
	 	display: inline;
		  white-space: nowrap;
		  overflow-x: scroll;
		  overflow-y: hidden
	}
	.time-nav-num{
		padding: 12px 30px;
		background-color: #27BEC4;
		color: #fff;
		 display:inline-block;
	}
	.MonthCative{
		background: #fff;
		color: #000;
		font-weight: 700;
	}
	#chart_line{
		height: 30vh;
		line-height: 20vh;
		font-size: 30px;
		font-weight: 700;
		color: #fff;
		text-align: center;
		background: #27BEC4;
	}
	.text{
		padding: 10px 0;
		background: #27BEC4;
		color: #fff;
		font-size: 20px;
		font-weight: 700;
		text-align: center;
		width: 100%;
	}
	.list{
		background: #27BEC4;
	}
	
	#chart_bar{
		height: 60vh;
	}
</style>